export const getThirdPartyIntegrationsUrl = () => '/agency/third_party_integrations';

export const updateThirdPartyIntegrationUrl = (provider: string) => `/agency/third_party_integrations/${provider}`;

export const toggleThirdPartyIntegrationUrl = (provider: string) =>
  `/agency/third_party_integrations/${provider}/toggle`;
